import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import WelcomeSection from './components/WelcomeSection';
import RegistrationForm from './components/RegistrationForm';
import Icon from '../../components/AppIcon';
import AuthPortalSwitcher from '../../components/ui/AuthPortalSwitcher';
import ProfessionalInviteBanner from '../../components/ui/ProfessionalInviteBanner';

/**
 * User registration only (property seekers).
 * Real estate agents use /pro/register.
 */
const Register = () => {
  useEffect(() => {
    document.title = 'User Registration | HireBroker';
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1 pt-16">
        <div className="container mx-auto px-4 py-8 lg:py-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto">
            <div className="hidden lg:block">
              <div className="sticky top-24">
                <WelcomeSection />
                <div className="mt-6 p-4 rounded-xl border border-border bg-card text-sm text-muted-foreground">
                  Are you an agent, broker, or advisor?{' '}
                  <Link to="/pro/register" className="text-primary font-medium underline">
                    Real Estate Agent registration
                  </Link>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div className="lg:hidden text-center space-y-3 mb-4">
                <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mx-auto">
                  <Icon name="Home" size={32} color="white" />
                </div>
                <h1 className="text-2xl font-bold text-foreground">User signup</h1>
                <p className="text-muted-foreground text-sm">
                  Create an account to search, save, and post property needs
                </p>
              </div>

              <div className="hidden lg:block text-center space-y-2 mb-2">
                <h1 className="text-3xl font-bold text-foreground">Create User Account</h1>
                <p className="text-muted-foreground">
                  For people looking to buy, rent, or invest
                </p>
              </div>

              <AuthPortalSwitcher mode="register" active="customer" />

              <div className="bg-card rounded-2xl shadow-lg border border-border p-6 lg:p-8">
                <RegistrationForm />
              </div>

              <ProfessionalInviteBanner compact />

              <div className="text-center space-y-3">
                <p className="text-muted-foreground text-sm">
                  Already have a user account?{' '}
                  <Link
                    to="/login"
                    className="font-medium text-primary hover:text-primary/80 transition-colors"
                  >
                    Sign in
                  </Link>
                </p>
                <p className="text-sm text-muted-foreground lg:hidden">
                  Real Estate Agent?{' '}
                  <Link to="/pro/register" className="text-primary font-medium underline">
                    Register as agent / broker / advisor
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Register;
